import { createContext, useContext, useRef, useState } from "react";
import { trackEvent } from "@/services/analytics";

const LeadModalContext = createContext(null);

export function LeadModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const returnFocusRef = useRef(null);

  const openLeadModal = (source = "unknown") => {
    returnFocusRef.current = document.activeElement;
    trackEvent("free_week_cta_clicked", { source });
    setIsOpen(true);
  };

  const closeLeadModal = () => {
    setIsOpen(false);
    window.setTimeout(() => returnFocusRef.current?.focus(), 0);
  };

  return (
    <LeadModalContext.Provider value={{ isOpen, openLeadModal, closeLeadModal }}>
      {children}
    </LeadModalContext.Provider>
  );
}

export function useLeadModal() {
  return useContext(LeadModalContext);
}
